import { useEffect, useState } from 'react'
import { Linking } from 'react-native'

import { useRoute } from '@react-navigation/native'
import TalkToExpert from '@zet/common/components/talkToExpert/talkToExpert'
import ToggleLanguage from '@zet/common/components/toggleLanguage'
import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { Icon, Stack, XStack, colors as zetColors } from '@zet/design-system'
import { Accordian } from '@zet/design-system/accordian'
import Pressable from '@zet/design-system/pressable'
import { B2, SH3 } from '@zet/design-system/typography'
import { APP_NAME } from '@zet/end-points'
import { useBrandDetailsById } from '@zet/feature-brands/api/brands/hooks'
import { i18n } from '@zet/localization'
import { ScrollView } from 'react-native-gesture-handler'

import { magnetIds } from '../../utils/constants'

export const BrandsHelpAndSupport = () => {
  const defaultLanguage = i18n.locale
  const [toogleLanguage, setToogleLanguage] = useState(
    defaultLanguage === 'hi' ? true : false
  )
  const [isDisabled, setIsDisabled] = useState(false)
  const [faqs, setFaqs] = useState([])
  const { params } = useRoute()
  const brandId = params?.brandId

  const { data: content } = useBrandDetailsById(brandId || '')

  useEffect(() => {
    if (content) {
      const arr: any = []
      if (content?.helpAndSupportFaqs) {
        content?.helpAndSupportFaqs[toogleLanguage ? 'hi' : 'en'].forEach(
          (element, index: number) => {
            arr.push({
              id: index,
              question: element.question,
              answer: element.answer,
            })
          }
        )
        setFaqs(arr)
      }
    }
  }, [content, toogleLanguage])

  return (
    <ScrollView
      className="flex-1 bg-white pt-4"
      showsVerticalScrollIndicator={false}
    >
      {faqs.length ? (
        <Stack className="px-3">
          <Stack className="mt-3 pb-3">
            <ToggleLanguage
              isDisabled={isDisabled}
              setIsDisabled={setIsDisabled}
              setToggleAccountType={setToogleLanguage}
              toggleAccountType={toogleLanguage}
              eventName="click_action"
              eventPayload={{
                item_name: 'brands_list_help_and_support_language_select',
              }}
            />
          </Stack>
          <B2 className="text-grays-80 mt-3">
            {i18n.t('brandHelpAndSupport.fAQs')}
          </B2>
          <Stack className="mt-3">
            {faqs.map((item, index) => (
              <Accordian
                key={`faq-${index}}`}
                title={item.question}
                content={item.answer}
                eventName="click_action"
                eventPayload={{
                  item_name: 'brands_list_help_and_support_faqs',
                  question_number: index + 1,
                }}
                brandId={brandId}
              />
            ))}
          </Stack>
          {APP_NAME === MY_TEAMS_ADVISOR ? <Stack className="mb-6" /> : null}
        </Stack>
      ) : (
        <></>
      )}
      {APP_NAME !== MY_TEAMS_ADVISOR && (
        <>
          <Stack className="px-3">
            <B2 className="text-grays-80 mt-3">
              {i18n.t('brandHelpAndSupport.contactUs')}
            </B2>
          </Stack>
          {brandId === magnetIds.brandId ? (
            <Stack className="mb-5 mt-2">
              <TalkToExpert />
            </Stack>
          ) : (
            <XStack className="my-3 space-x-2 px-3">
              <Pressable
                onPress={() => {
                  Linking.openURL(`tel:7417274072`)
                }}
                eventName="click_action"
                eventPayload={{
                  item_name: 'brands_list_help_and_support_contact_us',
                  type: 'phone_call',
                }}
              >
                <XStack className="border-grays-40 mb-3 items-center space-x-1 rounded-md border p-2">
                  <Icon
                    type="PhoneFilled"
                    color={zetColors.primary[100]}
                    size={30}
                  />
                  <SH3 className="my-2">
                    {i18n.t('brandHelpAndSupport.contactPhone')}
                  </SH3>
                </XStack>
              </Pressable>
            </XStack>
          )}
        </>
      )}
    </ScrollView>
  )
}
